import classNames from "classnames";
import React, { type ButtonHTMLAttributes } from "react";

import useCheckDevice from "@repo/shopify/hooks/useCheckDevice";

interface IProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  as?: "text" | "wrapper" | "square" | "notice";
  isActive?: boolean;
  variant?: "primary" | "secondary" | "tertiary";
  loading?: boolean;
}

export default function Button({
  className,
  children,
  type = "button",
  onClick,
  disabled,
  as = "wrapper",
  variant = "primary",
  isActive = true,
  loading = false,
  ...props
}: IProps) {
  return (
    <button
      className={classNames(
        "flex cursor-pointer disabled:cursor-not-allowed",
        !isActive && "text-dark-grey hover:text-black dark:hover:text-white",
        as === "text" && [
          variant === "primary" && "text-black dark:text-white",
          variant === "secondary" && "text-dark-grey hover:text-black dark:hover:text-white",
        ],
        as === "square" && [
          (variant === "primary" || variant === "secondary") && "pc:h-8.75 h-10 items-center justify-center px-3 py-1.5",
          variant === "primary" &&
            "disabled:bg-grey disabled:text-dark-grey border-black bg-black text-white dark:bg-white dark:text-black",
          variant === "secondary" &&
            "border-grey dark:border-dark-grey disabled:text-grey -flex w-fit flex-col gap-2.5 border bg-transparent whitespace-nowrap text-black disabled:bg-white dark:text-white",
          variant === "tertiary" &&
            "border-grey disabled:bg-grey disabled:text-dark-grey dark:border-dark-grey h-7.5 flex-col items-center justify-center gap-2.5 border bg-transparent px-3 py-1.5 whitespace-nowrap text-black dark:text-white",
        ],
        as === "notice" && ["border-grey pc:py-2 flex flex-col items-start! gap-1.5 border px-3 py-2.5 leading-none"],
        className,
      )}
      disabled={disabled || loading}
      onClick={onClick}
      type={type}
      {...props}
    >
      {loading ? "Loading..." : children}
    </button>
  );
}
